export default __webpack_public_path__ + "images/value_tags/nanoparticle_free-c237d9518dbf15e232a71719bddb36e3.svg";